import axios from 'axios'
import veItemBulkMfeConfig from '../config'
import { getUserSessionToken } from '../store/userProfile'
import store from '../store'

const apiType = {
  intendedUse: 'item_vendor_complete_state',
  itemType: 'item_types_by_state',
}

/**
 *
 * @param {*} getUserProfile
 * @param {*} itemTypeId
 * @returns
 */
export const getLovForValidationOptions = async (
  getUserProfile,
  itemTypeId,
) => {
  let url = `${veItemBulkMfeConfig.validation.url}lovs`
  try {
    const headers = {
      'x-api-key': veItemBulkMfeConfig.apiKey,
      user_id: getUserProfile?.lan_id,
      'Content-Type': 'application/json',
      source_system: 'LPP',
    }
    let vendorIds = []
    if (getUserProfile?.roles && getUserProfile?.roles?.includes('VENDOR')) {
      getUserProfile?.vendors?.forEach((eachVendorId) => {
        vendorIds.push(eachVendorId.id)
      })
    }
    let requestBody = {
      attribute_list: [],
      item_type: itemTypeId,
      vendor_id: vendorIds.length ? vendorIds : [],
      include_optional_udas: true,
    }
    const response = await axios.post(url, requestBody, { headers: headers })
    return response
  } catch (error) {
    console.debug('Error fetching Valid options LOV:', error)
    throw error
  }
}

/**
 *
 * @param {*} lovType
 * @param {*} getUserProfile
 * @param {*} itemState
 * @returns lov data
 */

export const getLovForExport = async (lovType, getUserProfile, itemState) => {
  const sessionToken = getUserSessionToken(store.getState())
  let url = `${veItemBulkMfeConfig.bulk.url}items/${apiType[lovType]}`
  try {
    const headers = {
      'x-api-key': veItemBulkMfeConfig.apiKey,
      User_id: sessionToken,
      'Content-Type': 'application/json',
    }
    //If vendor logs in,look for the vendor ids
    let vendorIds = []
    if (getUserProfile?.roles && getUserProfile?.roles?.includes('VENDOR')) {
      getUserProfile?.vendors?.forEach((eachVendorId) => {
        vendorIds.push(eachVendorId.id)
      })
    }
    let requestBody = { vendor_ids: vendorIds.length ? vendorIds : null }
    if (lovType === 'itemType') {
      requestBody = { ...requestBody, item_state: itemState }
    }
    const response = await axios.post(url, JSON.stringify(requestBody), {
      headers: headers,
    })
    return response
  } catch (error) {
    console.debug('Error fetching LOV:', error)
    throw error
  }
}
export const getItemTypesForReferenceSheet = async (getUserProfile) => {
  const sessionToken = getUserSessionToken(store.getState())
  const headers = {
    'x-api-key': veItemBulkMfeConfig.apiKey,
    User_id: sessionToken,
  }
  const vendorIds = []
  if (getUserProfile?.roles?.includes('VENDOR')) {
    getUserProfile?.vendors?.forEach((v) => vendorIds.push(v.id))
  }
  const qs = vendorIds.length
    ? `?vendorIds=${vendorIds.join(',')}`
    : '?vendorIds='
  const url = `${veItemBulkMfeConfig.bulk.url}item_type${qs}` // bulk.url already points to /v2/
  return axios.get(url, { headers })
}
